import { Component, ErrorInfo, ReactNode } from 'react';
import { Notifier } from '@airbrake/browser';

import { withAuth, IWithAuth } from 'providers';

interface IProps extends IWithAuth {
  airbrake: Notifier;
  children: ReactNode;
}

class ProtectedErrorBoundary extends Component<IProps> {
  componentDidCatch(error: Error, info: ErrorInfo): void {
    const { airbrake, auth } = this.props;

    airbrake.notify({
      error,
      params: { info, user_id: auth.data.id },
    });
  }

  render() {
    return this.props.children;
  }
}

export default withAuth(ProtectedErrorBoundary);
